var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import '../button/IconButton.js';
let FormModal = class FormModal extends LitElement {
    constructor() {
        super(...arguments);
        this.title = '';
        this.width = '520px';
    }
    handleClose() {
        this.remove();
        this.dispatchEvent(new CustomEvent('close', {
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
            <div class="modal" style="--form-modal-width: ${this.width}">
                <div class="header">
                    <h3>${this.title}</h3>
                    <icon-button
                        variant="danger"
                        size="small"
                        aria-label="${msg('Close', { id: 'modal.close', desc: 'Close button' })}"
                        icon-name="close"
                        @button-click=${this.handleClose}
                    ></icon-button>
                </div>
                <div class="content"><slot></slot></div>
            </div>
        `;
    }
};
FormModal.styles = css `
        :host {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1000;
        }

        .modal {
            background: white;
            border-radius: 8px;
            width: var(--form-modal-width, 520px);
            max-width: 90%;
            padding: 20px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between; /* Aligne le titre à gauche et le bouton à droite */
            font-size: 1.25rem;
            margin-bottom: 1rem;
            font-weight: bold;
            color: #1b96ff;
        }

        .footer {
            display: flex;
            justify-content: flex-end; /* Aligne les boutons à droite */
            gap: 10px;                 /* Espace entre les boutons */
            margin-top: 20px;          /* Espace entre le contenu et les boutons */
        }

        button {
            padding: 8px 12px;
            font-size: 14px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            color: white; /* Par défaut blanc pour les boutons */
        }

        button.submit {
            background-color: #007bff;
        }

        button.cancel {
            background-color: #ccc;
            color: black; /* Texte noir pour le bouton annuler */
        }

        simple-button,
        icon-button {
            margin-left: auto; /* Positionne le bouton à droite */
        }

        h3 {
            margin: 0;
        }
    `;
__decorate([
    property({ type: String })
], FormModal.prototype, "title", void 0);
__decorate([
    property({ type: String })
], FormModal.prototype, "width", void 0);
FormModal = __decorate([
    localized(),
    customElement('form-modal')
], FormModal);
export { FormModal };
//# sourceMappingURL=FormModal.js.map